
import axios from 'axios'
import { Trans } from '@/constants'

const LOCALE_KEY = 'locale'


export const setI18nLanguageInServices = (locale) => {
    const dir = locale === 'fa' ? 'rtl' : 'ltr'

    axios.defaults.headers.common['Accept-Language'] = locale

    window.document.querySelector('html').setAttribute('dir', dir)
    window.document.querySelector('html').setAttribute('lang', locale)
}

export const setLocalLocale = (locale) => {
    if(!Trans.SUPPORTED_LANGUAGES.includes(locale)) {
        throw new Error(`The ${locale} not supported yet.`)
    }

    // setI18nLanguageInServices(locale)

    window.localStorage.setItem(LOCALE_KEY, locale)

    return locale
}

export const getLocalLocale = () => {
    let locale = window.localStorage.getItem(LOCALE_KEY)

    if(!( locale && Trans.SUPPORTED_LANGUAGES.includes(locale) )) {
        setLocalLocale(Trans.DEFAULT_LANGUAGE)

        // locale = navigator.language.split('-')[0] || Trans.DEFAULT_LANGUAGE
        locale = Trans.DEFAULT_LANGUAGE
    }

    return locale
}
